/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum AuthFeature {
    UPDATE_CCU_TRACER = 'update_ccu_tracer',
    SITE_EDITOR = 'site_editor',
    INTERNAL = 'internal',
    LANDHOLDER_REPORTS = 'landholder_reports',
    PHOTOS_UPLOADER = 'photos_uploader',
    RASTER_LAYERS = 'raster_layers',
    ADMIN_ALL_COMPANIES = 'admin_all_companies',
    COMPANY_TOOLS = 'company_tools',
    EMISSIONS_RETURN_SURVEY = 'emissions_return_survey',
    CC_INVOICE_MANAGER = 'cc_invoice_manager',
}
